module.exports = __webpack_public_path__ + "img/control3.7dbaf5b5.svg";